import React, { useState, useEffect } from 'react';

import { useParams } from 'react-router-dom';

import ContractLineHeader from './ContractLineHeader';
import ContractLine from './ContractLine';

import * as http from './http';

const ContractsDetail = ({ className }) => {
  const { shipperId } = useParams();

  const [loadingShipper, setLoadingShipper] = useState(false);
  const [shipper, setShipper] = useState(null);
  const [contracts, setContracts] = useState([]);

  useEffect(() => {
    let didCancel = false;

    const fetchContracts = async () => {
      setContracts([]);
      try {
        const contracts = await http.getContracts(shipperId);
        if (!didCancel) {
          setContracts(contracts);
        }
      } catch (err) {
        console.error(err);
      }
    };

    const fetchShipper = async () => {
      setShipper(null);
      setLoadingShipper(true);
      try {
        const shipper = await http.getShipper(shipperId);
        if (!didCancel) {
          setShipper(shipper);
        }
      } catch (err) {
        console.error(err);
      } finally {
        if (!didCancel) {
          setLoadingShipper(false);
        }
      }
    };

    if (!shipperId) {
      return;
    }

    fetchContracts();
    fetchShipper();

    return () => {
      didCancel = true;
    };
  }, [shipperId]);

  const { company_name } = shipper || {};

  if (!shipperId || loadingShipper) {
    return null;
  }

  return (
    <div>
      <h1>Contracts for {company_name}</h1>
      <table width="100%" className="contractTable">
        <ContractLineHeader />
        {contracts.map((contract) => (
          <ContractLine key={contract.id} contract={contract} />
        ))}
      </table>
    </div>
  );
};

export default ContractsDetail;
